import {getAppState} from "../helpers/tools";
import {fetchLocations as makeLocations} from "../factories/locations";

/**
 *
 * @returns {Function}
 */
export const fetchLocations = () => {
  return (dispatch, getState) => {
    const state = getAppState( getState() );
    const history = state.actions.history;
    const prevHistory = history.slice();
    prevHistory.pop();
    const locations = makeLocations(history, prevHistory, 1);
    dispatch({
      type: "FETCH_LOCATIONS",
      data: {history, locations}
    });
  }
};
